import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import _get from 'lodash/get';
import { callHistorySelectors, callHistoryActions, featureSelectors, accountSelectors } from '@lifesize/nucleus';
import actions from 'actions/Contact';
import ActivityFeed from 'components/ActivityFeed/ActivityFeed';
import { routes } from 'constants/Application';
import { selectContact } from 'utils/contact-utils';

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleDeleteSelected: callId => dispatch(callHistoryActions.callHistoryDelete(callId)),
  handleVideoCall: dialString => dispatch(actions.startVideoCall(dialString)),
  handleAudioCall: dialString => dispatch(actions.startAudioCall(dialString)),
  handleChat: contact => {
    ownProps.history.push(routes.chat);
    dispatch(actions.chatWith(contact));
  },
  createContact: contact => {
    selectContact(contact, ownProps.history.push);
    dispatch(actions.createContact(contact));
  },
  selectContact: (contact, history) => dispatch(actions.selectContact(contact, true, history))
});

const mapStateToProps = (state) => {
  const callHistory = callHistorySelectors.callHistoryWeb(state);
  const isFeedLoaded = true;
  const isChatEnabled = featureSelectors.isChatEnabled(state) && accountSelectors.getAccountFeatures(state).isChatEnabled;

  return ({
    callHistory,
    hideContacts: _get(accountSelectors.getAccountFeatures(state),'hideContacts', false),
    hideMeetings: _get(accountSelectors.getAccountFeatures(state),'hideMeetings', false),
    hideRooms: _get(accountSelectors.getAccountFeatures(state),'hideRooms', false),
    isChatEnabled,
    isFeedLoaded,
    totalMissedCalls: callHistorySelectors.totalNewMissedCalls(state)
  });
};

export default withRouter(injectIntl(connect(
  mapStateToProps, mapDispatchToProps
)(ActivityFeed)));
